module.exports = __webpack_public_path__ + "static/media/volume_muted.67527469.svg";